var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          staticClass: "mb-0",
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.sidebar-fields",
                      modifiers: { "sidebar-fields": true }
                    }
                  ],
                  attrs: {
                    id: "table-settings",
                    size: "sm",
                    variant: "warning"
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tooltip",
                {
                  attrs: {
                    target: "table-settings",
                    triggers: "hover",
                    variant: "warning",
                    noninteractive: ""
                  }
                },
                [_vm._v("\n        Колонки\n      ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "filters-drawer",
        {
          attrs: {
            query: _vm.filters.query,
            "is-busy": _vm.isBusy,
            "filter-tags": _vm.activeFilterTags,
            "disabled-submit": _vm.isStartDateEmpty
          },
          on: {
            "update:query": function($event) {
              return _vm.$set(_vm.filters, "query", $event)
            },
            "remove-tag": _vm.removeFilterTag,
            submit: _vm.onSearch,
            clear: _vm.onClearFilters
          }
        },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Период")
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                { staticClass: "align-items-center" },
                [
                  _c(
                    "b-col",
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input_start_date",
                          size: "sm",
                          type: "date",
                          state: _vm.isStartDateEmpty ? false : null
                        },
                        model: {
                          value: _vm.filters.start_date,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "start_date", $$v)
                          },
                          expression: "filters.start_date"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "px-2", attrs: { cols: "auto" } },
                    [_c("span", [_vm._v("—")])]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input_end_date",
                          size: "sm",
                          type: "date"
                        },
                        model: {
                          value: _vm.filters.end_date,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "end_date", $$v)
                          },
                          expression: "filters.end_date"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isStartDateEmpty
            ? _c("b-col", [
                _c("small", { staticClass: "text-danger" }, [
                  _vm._v("Укажите дату начала периода!")
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-1", attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Заказчик")
              ]),
              _vm._v(" "),
              _c(
                "b-input-group",
                [
                  _c("b-form-input", {
                    ref: "customer_select",
                    attrs: {
                      id: "input_customer",
                      size: "sm",
                      type: "text",
                      readonly: "",
                      placeholder: _vm.$t(
                        "message.tasks.modal.customerPlaceholder"
                      )
                    },
                    model: {
                      value: _vm.customer.name,
                      callback: function($$v) {
                        _vm.$set(_vm.customer, "name", $$v)
                      },
                      expression: "customer.name"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-btn",
                        {
                          attrs: { size: "sm", variant: "outline-success" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.showCustomerTable()
                            }
                          }
                        },
                        [_vm._v("\n              Выбрать\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          attrs: { size: "sm" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.removeCustomer()
                            }
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: "times-circle" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "mt-1", attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Объект")
              ]),
              _vm._v(" "),
              _c(
                "b-form-select",
                {
                  staticStyle: { "min-width": "150px" },
                  attrs: { id: "select_location", size: "sm" },
                  model: {
                    value: _vm.filters.location_id,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "location_id", $$v)
                    },
                    expression: "filters.location_id"
                  }
                },
                [
                  _c("option", { domProps: { value: 0 } }, [
                    _vm._v("Все объекты")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.location_options, function(option) {
                    return _c("option", { domProps: { value: option.value } }, [
                      _vm._v(
                        "\n          " + _vm._s(option.text) + "\n        "
                      )
                    ])
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "customer_stat",
        staticClass: "mb-0 table-centered text-small",
        attrs: {
          id: "customer-stat",
          selectable: "",
          "select-mode": "single",
          selectedVariant: "success",
          striped: "",
          small: "",
          responsive: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.renderedFields,
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage,
          "sort-by": _vm.sortBy,
          "sort-desc": _vm.sortDesc,
          filter: _vm.filters.query,
          "sticky-header": "",
          "head-variant": "light"
        },
        on: {
          "update:busy": function($event) {
            _vm.isBusy = $event
          },
          "update:sortBy": function($event) {
            _vm.sortBy = $event
          },
          "update:sort-by": function($event) {
            _vm.sortBy = $event
          },
          "update:sortDesc": function($event) {
            _vm.sortDesc = $event
          },
          "update:sort-desc": function($event) {
            _vm.sortDesc = $event
          },
          filtered: _vm.onFiltered
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(task_id)",
            fn: function(row) {
              return [
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "link" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.showTask(row)
                      }
                    }
                  },
                  [_vm._v("\n        " + _vm._s(row.item.task_id) + "\n      ")]
                )
              ]
            }
          },
          {
            key: "cell(start_date)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatTableDateTime(row.item.start_date)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(total_hours)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.priceFormat(row.item.total_hours)) +
                    " " +
                    _vm._s(_vm.getStatsUnitShortName(row.item.unit_code)) +
                    "\n    "
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: {
          "total-rows": _vm.totalRows,
          "per-page": _vm.perPage,
          "page-options": _vm.pageOptions
        },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        },
        scopedSlots: _vm._u([
          {
            key: "footer-list",
            fn: function() {
              return [
                _c("div", [
                  _vm._v("\n        Заявок: "),
                  _c("b", [_vm._v(_vm._s(_vm.totalRows))]),
                  _vm._v(" |\n        Кол-во: "),
                  _c("b", [_vm._v(_vm._s(_vm.unitTotalsText))]),
                  _vm._v(" |\n        С заказчика: "),
                  _c("b", [_vm._v(_vm._s(_vm.priceFormat(_vm.totalCustomer)))]),
                  _vm._v(" |\n        Исполнителям: "),
                  _c("b", [
                    _vm._v(_vm._s(_vm.priceFormat(_vm.totalWorkerPrice)))
                  ])
                ])
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("customer-table-select", {
        ref: "customerTable",
        attrs: { town: 0 },
        on: { selectCustomer: _vm.updateCustomer }
      }),
      _vm._v(" "),
      _c("DynamicTables", {
        attrs: {
          "storage-key": "customerStatistic_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "task_id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c481636", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c481636","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Statistics/CustomerStatistic.vue
// module id = null
// module chunks = 